/**
 * Collection of user agent strings used by various monitoring services
 * This file serves as a central reference for conditionally enabling/disabling analytics
 */

// Datadog Synthetic Monitoring
// The default user agent for Datadog's synthetic tests always ends with "DatadogSynthetics"
const DATADOG_SYNTHETICS = "DatadogSynthetics";

// UptimeRobot Monitoring
// The string "UptimeRobot" is present in all UptimeRobot user agent strings
const UPTIME_ROBOT = "UptimeRobot";

// Uptime.com Monitoring
// User agents include "Uptime/" or "Uptimebot/" patterns
const UPTIME_COM = "Uptime";

// AWS CloudWatch Synthetics
// CloudWatch Synthetics canaries include this identifier in their user agent strings
const CLOUDWATCH_SYNTHETICS = "CloudWatchSynthetics";

//  Playwright E2E Testing
// The string "Playwright" is present in all Playwright user agent strings
const PLAYWRIGHT = "Playwright";

/**
 * Helper function to check if the current request is from a monitoring service
 * @returns boolean indicating if the request is from a monitoring service
 */
export const isMonitoringRequest = (): boolean => {
  const userAgent = navigator.userAgent;
  return (
    userAgent.includes(DATADOG_SYNTHETICS) ||
    userAgent.includes(UPTIME_ROBOT) ||
    userAgent.includes(UPTIME_COM) ||
    userAgent.includes(CLOUDWATCH_SYNTHETICS) ||
    userAgent.includes(PLAYWRIGHT)
  );
};
